import type { FC } from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../components/Buttons/Button'
import { startWebEamLogin } from '../features/auth/authSlice'
import { selectIsLoggedIn } from '../features/auth/selectors/authSelectors'
import { useAppDispatch, useAppSelector } from '../hooks'

const LoginPage: FC = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const isLoggedIn = useAppSelector(selectIsLoggedIn)

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/vehicles', { replace: true })
    }
  }, [isLoggedIn, navigate])

  return (
    <div style={{ display: 'grid', placeItems: 'center', height: '200px', gap: 16 }}>
      <p>Log in via WebEAM</p>
      <Button
        onClick={() => void dispatch(startWebEamLogin())}
        variant="primary"
        style={{ width: '160px' }}
      >
        Login
      </Button>
    </div>
  )
}

export default LoginPage
